<div [ngClass]="sidebarOpen ? 'navbar-open' : 'navbar-close'">
  <app-nav class="app-navbar"></app-nav>
  <div [ngClass]="sidebarOpen ? 'content-scroll-area nav-open' : 'content-scroll-area'">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>